/**
 * Countdown big-number overlay. Uses the wp7 spec's rule:
 *
 *   seconds = ceil( (phase.endsAtTick - latestTick) / tickRate )
 *
 * #276: `endsAtTick` is the SERVER's authoritative deadline (mirrored
 * verbatim from the sim's own `PhaseCountdown.endsAtTick`, on the
 * `matchPhase` message — see `SERVER_MATCH_PHASE_SCHEMA`). Previously this
 * component fabricated its own deadline by anchoring on the tick of the
 * FIRST countdown snapshot it happened to observe (`snap.tick +
 * COUNTDOWN_TICKS`), which was wrong whenever that snapshot wasn't near
 * tick 0 — e.g. reconnect, late-join, or spectate. Reading the real
 * deadline off the wire removes the guesswork entirely.
 */

import type { ReactElement } from "react";
import { useStore } from "../store/context.js";
import { ticksToSeconds } from "./hud-util.js";

const TICK_RATE = 30;

export function Countdown(): ReactElement {
  const { state } = useStore();
  if (state.phase.phase !== "countdown") return <></>;

  const tick = state.hudSnapshot?.tick ?? 0;
  const endsAtTick = state.phase.endsAtTick ?? tick;
  const nowSeconds = ticksToSeconds(endsAtTick, tick, TICK_RATE);

  return (
    <div
      data-testid="countdown"
      data-seconds={String(nowSeconds)}
      style={{
        position: "absolute",
        top: "40%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        fontSize: 96,
        fontWeight: 700,
        color: "#dfe6ef",
        textShadow: "0 2px 8px rgba(0,0,0,0.4)",
      }}
    >
      {nowSeconds}
    </div>
  );
}
